import { mergeAttributes, Node } from "@tiptap/core";

export const ReportTable = Node.create({
  name: "table",
  group: "block",
  content: "tableRow+",
  isolating: true,
  addAttributes() {
    return { align: { default: null } };
  },
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["table", mergeAttributes(HTMLAttributes), ["tbody", 0]];
  },
});

export const ReportTableRow = Node.create({
  name: "tableRow",
  content: "(tableHeader|tableCell)+",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["tr", mergeAttributes(HTMLAttributes), 0];
  },
});

export const ReportTableHeader = Node.create({
  name: "tableHeader",
  content: "block+",
  isolating: true,
  parseHTML() {
    return [{ tag: "th" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["th", mergeAttributes(HTMLAttributes), 0];
  },
});

export const ReportTableCell = Node.create({
  name: "tableCell",
  content: "block+",
  isolating: true,
  parseHTML() {
    return [{ tag: "td" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["td", mergeAttributes(HTMLAttributes), 0];
  },
});

export const ReportMdastOpaque = Node.create({
  name: "mdastOpaque",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  addAttributes() {
    return {
      node: { default: null },
      label: { default: "" },
    };
  },
  parseHTML() {
    return [{ tag: "span[data-mdast-opaque]" }];
  },
  renderHTML({ node }) {
    return [
      "span",
      {
        "data-mdast-opaque": "true",
        contenteditable: "false",
      },
      node.attrs.label,
    ];
  },
});

export const reportMdastEditorExtensions = [
  ReportTable,
  ReportTableRow,
  ReportTableHeader,
  ReportTableCell,
  ReportMdastOpaque,
];
